
    import './styles.scoped.css';
    export default {
  "content": "awsui_content_x6dl3_7yzrg_5",
  "icon": "awsui_icon_x6dl3_7yzrg_6",
  "actions": "awsui_actions_x6dl3_7yzrg_7",
  "secondary": "awsui_secondary_x6dl3_7yzrg_8"
};
  